import { createContext } from 'react';
import { MicrositeConfigType } from 'types';

export const MicrositeContext = createContext<MicrositeConfigType>(null);
